import { render, staticRenderFns } from "./PartDtlPopupContent.vue?vue&type=template&id=af41a1f4&"
import script from "./PartDtlPopupContent.vue?vue&type=script&lang=js&"
export * from "./PartDtlPopupContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports